import React, { useState } from 'react'
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoMdClose } from 'react-icons/io';
import emailjs from "@emailjs/browser";
const PopUp = () => {
  const [toggle, setToggle] = useState(false);
    const CloseClick = () => {
      setToggle(false);
  
    };
    const [ismobile, setIsmobile] = useState(0);
  
    // const { categorytotal } = useSelector((store) => store.categoryAll);
  
  
    const [showAbout, setShowAbout] = useState(true);
    const [showInterior, setShowInterior] = useState(true);
    const [showGallery, setShowGallery] = useState(true);
  
    const closemenu = () => {
      document.getElementById("mytogglebtn").classList.add("collapsed");
      document.getElementById("menu").classList.remove("in");
    };
  
  
  
    const [name, setName] = useState("");
    const [mail, setmail] = useState("");
    const [massages, setMassages] = useState("");
    const [number, setNumber] = useState("");
    const [state, setState] = useState("");
    const [subject, setSubject] = useState("");
    const [city, setCity] = useState("");
  
    const nameChange = (e) => {
      const value = e.target.value;
      setName(value);
    };
    const stateChange = (e) => {
      const value = e.target.value;
      setState(value);
    };
    const cityChange = (e) => {
      const value = e.target.value;
      setCity(value);
    };
    const subjectChange = (e) => {
      const value = e.target.value;
      setSubject(value);
    };
    const numberChange = (e) => {
      const value = e.target.value;
      setNumber(value);
    };
  
    const mailChange = (e) => {
      const value = e.target.value;
      setmail(value);
    };
    const massagesChange = (e) => {
      const value = e.target.value;
      setMassages(value);
    };
  
  
    const sendEmail = (e) => {
      e.preventDefault();
      emailjs
        .sendForm(
  
        // "service_oumku8k",
        // "template_esy4tqm",
        // "#myForm",
        // "8i7i_APkS7sZ9CqPl"
      )
        .then(
          function (response) {
            console.log("SUCCESS!", response.status, response.text);
            if (response.text === "OK") {
              setName("");
              setmail("");
              setMassages("");
              setNumber("");
              setState("");
              setSubject("");
              setCity("");
  
            }
          },
          function (error) {
            console.log("FAILED...", error);
          }
        );
    };
  return (
    <>

      {/* PopUp */}

      <div className="container" style={{ marginBottom: "" }}>
        <div className="row">
          <div className="col-md-12">
            <div className="modal" id="mypopUpForm">
              <div className="modal-dialog">
                <div className="modal-content">
                  {/* <div className="modal-header">
                    <h5 style={{ color: '#000' }}>
                      <i className="fa fa-desktop"> </i> &nbsp;Important Notice from
                      <i className="fa fa-hospital" style={{ color: "red" }}> </i>  <span style={{ color: '#0f903f' }}> Welcome to Yogesh Solar Energy !</span>
                      </h5>
                    <button  onClick={closemenu} style={{ color: "#0f903f" }} className="close" data-dismiss="modal"><b  onClick={closemenu} style={{ color: "#0f903f" }}>X</b></button>
                  </div> */}
                  <div className="modal-body">

                    <section id="features" className="features">
                      <div className="" data-aos="fade-up">
                        <div className="row">

                          <div className="col-lg-12" data-aos="fade-left" data-aos-delay={100}>
                            {/* <b style={{ textAlign: "center", color: "#0f903f", fontSize: "20px" }}>Coming soon !</b> */}
                            {/* <img src="assets/img/giphy.gif" alt  style={{height:"40px", width:"120px"}}/>
                            <br />
                            <br /> */}
                            {/* <p>It has come to our attention that some third-party entities are promoting Green Ville Projects' ventures under different investment plans, including fractional ownership and other schemes.</p> */}

                            <img src="assets/yog/pop.webp" style={{borderRadius:"5px"}} alt />

                            {/* <div className="icon-box mt-2 mt-lg-0" data-aos="zoom-in" data-aos-delay={150}>
                                  <i className="bx bx-receipt" />
                                  <p>⚠️ We want to clarify that Green Ville Projects PVT Ltd has NOT partnered with any company or individual for such promotions.</p>
                                </div>
                                <div className="icon-box mt-2" data-aos="zoom-in" data-aos-delay={150}>
                                  <i className="bx bx-cube-alt" />
                                  <p>✅ Our projects and investment options are handled exclusively by Green Ville Projects, and we take NO responsibility for any misleading claims made by unauthorized sources.</p>
                                </div>
                                <div className="icon-box mt-2" data-aos="zoom-in" data-aos-delay={150}>
                                  <i className="bx bx-images" />
                                  <p>💬 For genuine and verified information, always reach out to us directly through our official communication channels.</p>
                                </div> */}

                          </div>
                        </div>
                        <div className="" data-aos="zoom-in" data-aos-delay={150}>
                          <i className="bx bx-shield" />
                          {/* <p style={{ color: '#8d0000ff' }}>📞 Contact us at:  <a href="tel:+91 9165155945"><b style={{ color: '#8d0000ff' }}> +91 9165155945 </b> </a></p> */}
                          {/* <p><a href="tel:+91 7509182172"><b>  +91 7509182172 </b> </a></p> */}
                          {/* <p>🌐 Website: <a href='https://satnaswastikhospital.in/' target="_blank"> <b>https://satnaswastikhospital.in</b></a></p> */}
                        </div>
                        {/* <h5 style={{ color: '#000' }}><i className=""> </i> &nbsp;
                          <span style={{ color: '#8d0000ff' }}> बड़े शहरों जैसी स्वास्थ्य सुविधा अब  रायपुर शहर में.</span></h5> */}

                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </>
  )
}

export default PopUp